import { StepIDs } from '../constants/stepConstants'
import { StepState } from '../types/steps'

interface StepOptions {
    title: string
    description?: string
    secondaryDescription?: string
    state?: StepState
}
class Step {
    id: StepIDs
    title: string
    description?: string
    secondaryDescription?: string
    state?: StepState

    constructor(id: StepIDs, options: StepOptions) {
        this.id = id
        this.title = options.title
        this.description = options.description
        this.secondaryDescription = options.secondaryDescription
        this.state = options.state || StepState.TO_DO
    }

    public get isToDo(): boolean {
        return this.state === StepState.TO_DO
    }

    public get isPending(): boolean {
        return this.state === StepState.PENDING
    }

    public get isDone(): boolean {
        return this.state === StepState.DONE
    }

    public getDescription(flag: boolean): string {
        return this.description
    }

    public setState = (state: StepState) => {
        this.state = state
    }
}

export class StepOne extends Step {
    constructor(options: StepOptions) {
        super(StepIDs.ONE, options)
    }
}
export class StepTwo extends Step {
    constructor(options: StepOptions) {
        super(StepIDs.TWO, options)
    }
}
export class StepThree extends Step {
    constructor(options: StepOptions) {
        super(StepIDs.THREE, options)
    }
}
export class StepFour extends Step {
    constructor(options: StepOptions) {
        super(StepIDs.FOUR, options)
    }

    /** If an external signer was selected */
    public getDescription(isExternal: boolean): string {
        return isExternal ? this.secondaryDescription : this.description
    }
}

export default Step
